<template>
  <div class="step">
    <h2 class="h2 text-light">Objecten</h2>
    <h1 class="h1">Wat wil je laten vervoeren?</h1>

    <Object
      v-for="(object, key) in $v.voorwerpen.$each.$iter"
      :key="key"
      :object="object"
      :index="key"
    />

    <button class="btn btn__bordered btn__addObj" @click="addObject">
      + Object toevoegen
    </button>

    <button @click="nextStep" class="btn btn__filled w-100">Volgende</button>
    <button
      @click="goToPreviousRoute"
      class="btn btn__simple btn__left btn__backbt"
    >
      <i class="fas fa-chevron-left"></i> Terug
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Object from "@/components/Object";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "Objects",
  components: {
    Object
  },
  computed: {
    ...mapFields(["voorwerpen"])
  },
  data() {
    return {
      submitted: false
    };
  },
  watch: {
    voorwerpen(oldVal, newVal) {
      if (newVal.length === 0) {
        this.addObject();
      }
    }
  },
  methods: {
    addObject() {
      this.voorwerpen.push({
        type: null,
        lengte: null,
        breedte: null,
        hoogte: null,
        aantal: 1,
        koerier: "nee",
        omschrijving: "",
        gewicht: "0-34kg",
        oudspulmeenemen: "nee",
        demontagemontage: "nee",
        packing: "nee"
      });
    },
    removeObject(index) {
      this.voorwerpen.splice(index, 1);
    },
    nextStep() {
      this.$v.$touch();
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }

      this.$root.goToNextRoute();
    }
  },
  validations: {
    voorwerpen: {
      required,
      minLength: minLength(1),
      $each: {
        gewicht: {
          required
        },
        omschrijving: {
          required
        },
        aantal: {
          required
        },
        type: {
          required
        },
        koerier: {
          required
        },
        lengte: {
          required
        },
        breedte: {
          required
        },
        hoogte: {
          required
        },
        oudspulmeenemen: {
          required
        },
        demontagemontage: {
          required
        },
        packing: {
          required
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  margin-top: 20px;
  margin-bottom: 0;
}
.btn.btn__filled.w-100 {
  margin-top: 20px;
}
</style>
